import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import Form from 'ui/components/Form.js'



export default class Gatekeeper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clicked: false
        }
    }


    componentDidMount() {}

    render() {
        const {
            bodyText,
            id
        } = this.props

        return (
            <Wrapper>
                <TextWrapper>
                    <Title />
                    <Text dangerouslySetInnerHTML={{ __html: bodyText }}>
                    </Text>
                </TextWrapper>
                <FormWrapper>
                    <Form id={id}>
                    </Form> 
                </FormWrapper>
            </Wrapper>
        )
    }
}

// Styles


const Wrapper = styled.div`
width: 100%;
margin-top: 200px;
display: flex;
background-color: rgb(245,245,245);
`
const ClickClack = styled.button`

`
const TextWrapper = styled.div`
width: 50%;
padding: 2%;
`

const Text = styled.div`
`
const Title = styled.h2`

`

const FormWrapper = styled.div`
width: 50%;
display: flex;
padding: 2%;
`

const Mirek = styled.div`
&&#form-container {
    * {
      font-family: "Work Sans";
      color: white;
      font-size: 16px;
    }

    ._form-content{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    ._field1, ._x29757849 {
      display: none;
    }

    #field[1]{
      display: none !important;
    }

    ._x06147226 {
      width: 40%;
      flex-grow: 2;
    }

    ._x74459413 {
      width: 40%;
      flex-grow: 2;
      margin-left: 5%;
    }

    ._field32 {
      width: 40%
      flex-grow: 2;
    }

    
    ._field32 option {
      width: 80%;
    } 

    ._field57 {
      width: 40%;
      flex-grow: 2;
      margin-left: 5%;
    }

    ._field57 option {
      width: 80%;
    }

    textarea {
      background: #295F8D;
      color: white !important;
      transition: all 0.2s !important;
    }

    textarea:focus {
      height: 8em !important;
    }

    form {
      width: 100%;
      margin: 0;
      padding: 0;
      background: none !important;
    }

    p {
      font-size: 16px !important;
    }

    ._form-title {
      font-weight: 300;
      font-size: 30px;
      line-height: 45px;
    }

    ._form-label {
      font-weight: 500;
    }

    ._form_element {
      margin-bottom: 1.5em;
    }
    
    ._field-wrapper {
      select,
      input {
        background: #295F8D;
        color: white !important;
        border: none;
        border-radius: 0;
        padding: 1em 0.5em;

        &::placeholder {
          color: white;
        }
      }
    }

    ._submit {
      background: #00994c !important;
      text-transform: uppercase;
      border-radius: 2em !important;
      padding: 0.5em 1.5em !important;
      transition: all .2s ease-in-out !important;
    }

    ._submit:hover {
      background: #00994cad !important;
    }

    .disabled {
      background-color: grey !important;
    }

    .disabled:hover{
      background-color: grey !important;
    }

    ._form-branding {
      display: none;
    }

    ._form-fieldset > div > span {
      color: red !important;
    }

  }
`


// WEBPACK FOOTER //
// ./src/ui/components/modules/Gatekeeper/index.js